module.exports = __webpack_public_path__ + "img/Photography-logo-design-Tashii-Designs.7809a35e.jpg";